export class Mailgroup {

  mailgroupid: number;
  mailgroup: string;
  active: number;
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;

}

export class MailGroupDetails {
  mailgroupdetailid: number;
  userid: number;
  username: string;
  firstname: string;
  lastname: string;
  emailid: string
  mailgroupid: number;
  mailgroup: string;
  touserid: number;
  ccuserid: number;
  active: number;
  createdby: number;
  createdon: string;
  modifiedby: number;
  modifiedon: string;
  loadedfromdatabase: boolean
}






